import Vue from "vue";
import VueI18n from "vue-i18n";
Vue.use(VueI18n); // 全局挂载
 
export const i18n = new VueI18n({
  locale: localStorage.getItem("locale") || "en", // 从localStorage中获取 默认英文
  messages: {
    en: require("./langs/en"), // 英文语言包
    zh: require("./langs/zh"), // 中文语言包
    fa: require("./langs/fa"), // 法语言包
    ar: require("./langs/ar"), // 阿拉伯语言包
    han: require("./langs/han"), // 韩语言包
    id: require("./langs/id"), // 印尼语言包
    jp: require("./langs/jp"), // 日语言包
    pu: require("./langs/pu"), // 葡萄牙语言包
    th: require("./langs/th"), // 泰语言包
    tu: require("./langs/tu"), // 土耳其语言包
    vi: require("./langs/vi"), // 越南语言包
    xi: require("./langs/xi") // 西班牙语言包
  }
});
 
export default i18n;


// WEBPACK FOOTER //
// ./src/i18n/index.js